import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { CoreModule } from 'src/app/core/core.module';
import { CasesPendingApprovalListComponent } from './cases-pending-approval-list/cases-pending-approval-list.component';
import { CasesPendingApprovalRoutingModule } from './cases-pending-approval-routing.module';
import { TagModule } from "primeng/tag";
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';

@NgModule({
  declarations: [
    CasesPendingApprovalListComponent
  ],
  imports: [
    CoreModule,
    CommonModule,
    FormsModule,
    TableModule,
    DropdownModule,
    InputTextModule,
    CalendarModule,
    ButtonModule,
    CasesPendingApprovalRoutingModule,
    TagModule,
    TooltipModule,
    MultiSelectModule
]
})
export class CasesPendingApprovalModule { }
